import Extend from 'flarum/common/extenders';
import commonExtend from '../common/extend';
import HomePage from './components/HomePage';
export default [...commonExtend,
// Register the custom BlueEmotion homepage as a reactive forum route.
// The route NAME ('glowingblue-demo.home') must match the PHP-side
// Frontend->route() name in extend.php so a hard navigation to /home
// (server-served SPA shell) resolves to this same component.
//
// IMPORTANT: this is the canonical Flarum 2.x way to add a frontend
// route. Assigning `app.routes[name] = {...}` inside an initializer does
// NOT wire the component into Mithril's reactive router — it renders once
// from the server bootstrap and then freezes (no redraws, no SPA mount).
new Extend.Routes() //
.add('glowingblue-demo-home', '/home', HomePage)];